/* 🤖 this file was generated by script */
export const wiconSwitchHorizontal01 = {
  name: 'switch_horizontal_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 17H4m0 0l4-4m-4 4l4 4M4 7h16m0 0l-4-4m4 4l-4 4"/></svg>`,
};
